import { createReducer } from '@reduxjs/toolkit'

import {
  zaConfig,
  cancelZaConfig,
  updateStatus,
  zaGetAppContext,
} from './actions'

const initialState = {
  zaConfig: null,
  zaRunningContext: '',
  zaConfigPending: false,
  zaConfigError: null,
  zaConfigScheduled: false,
  status: '',
  zaGetAppContext: null,
}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(zaConfig.fulfilled, (state, action) => {
      state.zaConfig = action.payload
      state.zaRunningContext = action.payload.runningContext
      state.zaConfigPending = false
      state.zaConfigError = null
      state.zaConfigScheduled = true
      return state
    })
    .addCase(zaConfig.pending, (state, action) => {
      state.zaConfigPending = true
      state.zaConfigScheduled = false
      return state
    })
    .addCase(zaConfig.rejected, (state, action) => {
      state.zaConfigPending = false
      state.zaConfigError = action.error
      state.zaConfigScheduled = false
      return state
    })
    .addCase(cancelZaConfig, (state, action) => {
      state.zaConfigScheduled = false
      return state
    })
    .addCase(updateStatus, (state, action) => {
      state.status = action.payload
    })
    .addCase(zaGetAppContext.pending, (state, action) => {
      state.zaGetAppContext = action.payload
      return state
    })
    .addCase(zaGetAppContext.fulfilled, (state, action) => {
      state.zaGetAppContext = action.payload
      return state
    })
    .addCase(zaGetAppContext.rejected, (state, action) => {
      state.zaGetAppContext = action.payload
      return state
    })
    .addDefaultCase((state, action) => {
      return state
    })
})

export function selectIsZaConfigPending(state) {
  return state.app.zaConfigPending
}

export function selectZaConfigError(state) {
  return state.app.zaConfigError
}

export function selectZaConfig(state) {
  return state.app.zaConfig
}

export function selectZaRunningContext(state) {
  return state.app.zaRunningContext
}

export function selectIsZaConfigScheduled(state) {
  return state.app.zaConfigScheduled
}

export function selectStatus(state) {
  return state.app.status
}
